import { render, staticRenderFns } from "./RepairTable.vue?vue&type=template&id=207237d8&scoped=true"
import script from "./RepairTable.vue?vue&type=script&lang=js"
export * from "./RepairTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207237d8",
  null
  
)

export default component.exports